import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('div')`
  position: relative;
  margin: 0 -${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    margin: 0;
  `};
`;

export const ChartWrapper = styled('div')`
  position: relative;
`;

export const Chart = styled('svg')`
  position: absolute;
  bottom: 0px;
`;

export const Legend = styled('div')`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  ${media.smDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `};
`;
